"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9241],{

/***/ 9241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 15h-13C3.4 15 2 12.3 2 10.5V7c0-.3.1-.6.4-.8.3-.2.6-.2.9-.2.8.3 3 .9 3.8 1h11.4c.3 0 .6.1.8.3l2.5 3c.3.4.3.9 0 1.3l-2.5 3c-.2.3-.5.4-.8.4zm-.5-2l1.7-2L18 9h-1v4h1zM6.9 9C6.2 8.9 5 8.6 4 8.3v2.2c0 1 .9 2.5 1.5 2.5H15V9H6.9zm8.4 9.3c.5-.6 1.3-1.3 2.7-1.3 1.851 0 3.236 1.71 3.675 2.252.06.072.101.124.125.148.4.5.3 1.1-.2 1.4-.2.1-.4.2-.6.2-.3 0-.6-.1-.8-.4-.3-.4-1.3-1.6-2.2-1.6-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.4 0-2.2-.7-2.7-1.3-.5-.5-.7-.7-1.3-.7-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.851 0-3.236-1.71-3.675-2.252-.06-.073-.101-.124-.125-.148-.4-.5-.3-1.1.2-1.4.5-.4 1.1-.3 1.4.2.3.4 1.3 1.6 2.2 1.6.6 0 .8-.2 1.3-.7.5-.6 1.3-1.3 2.7-1.3 1.4 0 2.2.7 2.7 1.3.5.5.7.7 1.3.7.6 0 .8-.2 1.3-.7z"
}), "BananaBoating"));


/***/ })

}]);